import { useTranslation } from 'react-i18next';
import TextReveal from "../@/components/magicui/text-reveal";
import RetroGrid from "../@/components/ui/retro-grid";

export function TextRevealDemo() {
  const { t } = useTranslation();
  
  return (
    <div className="relative z-10 flex min-h-[16rem] items-center justify-center rounded-lg font-secondary text-center bg-black">
      <RetroGrid />
      <TextReveal text={t('textReveal.title')} />
    </div>
  );
}

export default TextRevealDemo;